if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      this.setupBuyButton();
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * True when the product has a single variant: either no option picker,
     * or every option in the picker has only one value (e.g. Size: 50 Feet).
     */
    isSingleVariant() {
      const picker = this.productSection.querySelector('.product-options');
      if (!picker) return true;

      const counts = {};
      picker.querySelectorAll('input[type="radio"][name]').forEach((input) => {
        counts[input.name] = (counts[input.name] || 0) + 1;
      });
      const radioGroups = Object.values(counts);
      if (radioGroups.some((n) => n > 1)) return false;

      const selects = picker.querySelectorAll('select');
      for (let i = 0; i < selects.length; i += 1) {
        if (selects[i].options.length > 1) return false;
      }
      return true;
    }

    /**
     * 21 Oct: make the sticky button a primary buy button.
     * Single-variant products get a real "Add to cart" that submits the main form;
     * products with a real choice keep "Choose options" (jumps to the picker).
     */
    setupBuyButton() {
      const btn = this.querySelector('.card__buttons .btn');
      if (!btn) return;
      btn.classList.remove('btn--secondary');
      btn.classList.add('btn--primary');

      const mainAdd = this.productSection.querySelector('.js-product-form-main [name="add"]');
      if (!mainAdd || !this.isSingleVariant()) return;

      btn.textContent = mainAdd.dataset.addToCartText || mainAdd.textContent.trim() || 'Add to cart';
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (mainAdd.disabled) return;
        mainAdd.click();
      });
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
